<template>
  <div class="foundation">
    <div class="entry">
      <div class="item_entry">
        <h3>入驻公益节点，实现极速筹款</h3>
        <h4>
          目前已有
          <i>{{nums}}</i> 个公募基金会加入
        </h4>
        <!-- <div class="apply_join">申请加入</div> -->
      </div>
    </div>
    <!-- Slider -->
    <Slider height="750px" :interval="5000" :control-btn="false" :indicators="false">
      <!-- SliderItem -->
      <SliderItem class="carousel" v-for="(gitem, gi) in OrgsList" :key="gi">
        <div class="item" v-for="(item, i) in OrgsList[gi]" :key="i">
          <div class="project_wrap">
            <h2 class="item_title">{{item.name}}</h2>
            <div class="con_img">
              <div class="product_content">
                <p class="item_intro">{{item.detail}}</p>
                <div class="item_bottom">
                  <div class="item_bottom_num">
                    总筹款
                    <span>{{item.donate_total}}</span> 元
                  </div>
                  <div class="item_bottom_num">
                    总支持
                    <span>{{item.order_total}}</span> 次
                  </div>
                </div>
              </div>
              <div class="product_img">
                <img data-original="#" :src="item.cover" class="lazyload" style="display: inline;">
              </div>
            </div>
          </div>
        </div>
      </SliderItem>
    </Slider>
  </div>
</template>
<script>
import axios from "axios";
import { Slider, SliderItem } from "vue-easy-slider";
export default {
  data() {
    return {
      OrgsList: [],
      groupList: [],
      height: "600px",
      nums: 100
    };
  },
  methods: {
    getOrgs() {
      let that = this;
      axios
        .get("https://partner-gateway.qschou.com/official/orgs?type=1")
        .then(res => {
          res = res.data;
          that.nums = res.data.list.length;
          if (res.code === 0) {
            //this.OrgsList = res.data
            let list = res.data.list.filter(item => {
              return parseInt(item.donate_total, 10) > 0;
            });            
            let _t = list.length;
            if (_t > 60) {
              list = list.slice(0, 60);
              _t = 60;
            }
            list = list.sort(() => {
              return Math.random() - 0.5
            });
            let arr = [];
            for (let i = 0; i < _t; i++) {
              let b = parseInt(i / 6, 10);
              if (!arr[b]) arr[b] = [];
              arr[b].push(list[i]);
            }
            that.OrgsList = arr;
          }
        });
    }
  },
  created() {
    this.height = document.body.clientHeight - 500 + "px";
    this.getOrgs();
  },
  components: {
    Slider,
    SliderItem
  }
};
</script>

<style lang="less" scoped>
a {
  padding: 0;
  margin: 0;
  list-style: none;
  font-style: normal;
  text-decoration: none;
  border: none;
  font-family: Microsoft Yahei, sans-serif;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
}
.foundation {
  width: 98%;
  margin: 0 auto;
  .entry {
    .item_entry {
      background-image: url(../../src/assets/public_log.png);
      background-repeat: no-repeat;
      background-size: cover;
      height: 120px;
      h3,
      h4 {
        margin: 0;
      }
      h3 {
        font-size: 34px;
        color: #fff;
        font-weight: 600;
        padding-top: 18px;
      }
      h4 {
        font-size: 22px;
        color: #fff;
        font-weight: 500;
        padding-top: 8px;
        line-height: 24px;
        i {
          font-size: 20px;
        }
      }
      .apply_join {
        padding: 3px 10px;
        background-color: #fff;
        width: 87px;
        margin: 0 auto;
        border-radius: 20px;
        margin-top: 5px;
        color: #7e1505;
        font-size: 13px;
        line-height: 18px;
      }
    }
  }
  .con_img {
    display: flex;
    width: 100%;
  }
  h2.item_title {
    width: 100%;
    margin: 0;
    font-size: 40px;
    color: #333;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
  }
  .item {
    display: inline-block;
    margin-top: 12px;
    width: 32%;
    .project_wrap {
      display: flex;
      flex-direction: column;
      margin: 5px;
      padding: 80px 30px;
      background-color: #fff;
      border-radius: 4px;
      align-items: center;
      border: 1px solid #eee;
      box-shadow: 0 5px 20px hsla(0, 0%, 85%, 0.5);
      transition: all 0.3s linear;
      &:hover {
        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
      }
      .product_content {
        flex: 1;
        padding-right: 18px;
        text-align: left;
        width: 60%;

        .item_intro {
          height: 70px;
          margin: 10px 0 22px 0;
          font-size: 22px;
          color: #999;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          overflow: hidden;
          -webkit-box-orient: vertical;
          line-height: 35px;
        }
        .item_bottom {
          display: flex;
          .item_bottom_num {
            padding-right: 60px;
            font-size: 22px;
            color: #999;
            white-space: nowrap;
            span {
              color: #ed2424;
            }
          }
        }
      }
      .product_img {
        width: 100px;
        height: 100px;
        margin: 10px auto;
        img {
          border-radius: 50%;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .item:nth-child(3n+2)
  {
    padding: 0 2%;
  }
}
.slider {
  position: relative;
  .slider-item {
    width: 100%;

    display: flex;
    flex-wrap: wrap;
    align-content: space-around;
  }
  .btn,
  .btn-left,
  .indicators {
    display: none;
  }
}
</style>
